import * as React from 'react';
import {connect} from 'react-redux';
import {flow} from 'lodash';
import {Row} from 'react-bootstrap';
import {RouteComponentProps, withRouter} from 'react-router';
import {bindActionCreators} from 'redux';
import {withJob} from 'react-jobs';
import {actions as contentActions, getContentFromState, IContentActions} from '../../services/content/reducer';
import Loading from '../../components/Loading/index';
import {push} from 'react-router-redux';
import {IStore} from '../../redux/IStore';
import {IContentStore} from '../../services/content/models';
import templateMap from './templateMap';

interface IContentProps extends RouteComponentProps<any> {
  content: IContentStore;
  actions: {
    content: IContentActions;
    push: (route: string) => void;
  };
  steps: any[];
}

function shouldDeferLoading({steps, location}: IContentProps): boolean {
  let isInQuoteProcess = false;

  steps.forEach((step) => {
    if (step.route === location.pathname) {
      isInQuoteProcess = true;
    }
  });

  if (isInQuoteProcess) {
    return true;
  }

  let isInCustomerArea = false;

  if (location.pathname.includes('/account') ||
    location.pathname.includes('/auth') ||
    location.pathname.includes('/password') ||
    location.pathname.includes('/complaints')
  ) {
    isInCustomerArea = true;
  }

  if (isInCustomerArea) {
    return true;
  }

  return false;
}

class Content extends React.Component<IContentProps> {

  public componentWillReceiveProps(nextProps: IContentProps) {
    let isInQuoteProcess = false;

    nextProps.steps.forEach((step) => {
      if (step.route === nextProps.location.pathname && step.route !== '/') {
        isInQuoteProcess = true;
      }
    });

    if (isInQuoteProcess) {
      return;
    }

    if (this.props.location.pathname !== nextProps.location.pathname) {
      nextProps.actions.content.getContent({
        slug: nextProps.location.pathname,
      });
    }
  }

  private renderLoading = () => {
    return (
      <div className="container">
        <Row className="internal-page-container">
          <div className="internal-page-content loading">
            <Loading/>

            Please Wait...
          </div>
        </Row>
      </div>
    );
  }

  public render() {
    const {content, location} = this.props;
    const deferLoading = shouldDeferLoading(this.props);

    if (deferLoading) {
      return null;
    }

    const page = getContentFromState(content, location.pathname);

    if (content.requesting) {
      return this.renderLoading();
    }

    if (content.content.length === 0 || !page) {
      return null;
    }

    const Template = templateMap[page.templateKey];

    return (
      <div>
        <div className="">
          <Template page={page} content={content}/>
        </div>
      </div>
    );
  }
}

export default flow([
  withJob({
    work: (props: IContentProps) => {
      const promises = [];

      if (!props.content.pages || props.content.pages.length === 0) {
        promises.push(props.actions.content.loadPageList());
      }
      if (!props.content.pages || props.content.pages.length === 0) {
        promises.push(props.actions.content.getContent({
          slug: props.location.pathname,
        }));
      }

      return Promise.all(promises);
    },
    LoadingComponent: (props) => <Loading/>,
    ErrorComponent: ({error}) => {
      console.error(error);

      return (
        <div>
          {error.message}
        </div>
      );
    },
  }),
  connect(
    (state: IStore) => ({
      content: state.content,
    }),
    (dispatch) => ({
      actions: {
        content: bindActionCreators({...contentActions}, dispatch),
        push: bindActionCreators(push, dispatch),
      },
    }),
  ),
  withRouter,
])(Content);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/scenes/Content/index.tsx